export default {
  vdoLiveSet: {
    id: '',
    liveClassScheduleId: '',
    sectionNo: null,
    code: '',
    descriptionLocal: 0,
    descriptionEng: '',
    totalVdoLength: 0,
    vdoLiveSetTopics: [],
  },
  vdoLiveSets: [],
  processing: false,
  error: null,
  success: null,
}



